(() => {
  if (window.mskGrapeMenuLoaded) return;
  window.mskGrapeMenuLoaded = true;
  // Both menus share one result and one request per collection. Results live
  // only in this page, never in a cache shared across customer/company logins.
  async function initializeGrapeMenus() {
    const groups = [...document.querySelectorAll('[data-grape-group]')];
    const entries = new Map();
    for (const group of groups) {
      for (const element of group.querySelectorAll('[data-grape-item]')) {
        const key = element.dataset.grapeItem;
        if (!entries.has(key)) entries.set(key, {
          state: element.dataset.grapeState,
          url: element.dataset.grapeUrl,
        });
      }
    }
    const update = () => {
      const focusedItem = document.activeElement?.closest('[data-grape-item]');
      for (const group of groups) {
        let visible = 0;
        for (const element of group.querySelectorAll('[data-grape-item]')) {
          const entry = entries.get(element.dataset.grapeItem);
          element.dataset.grapeState = entry.state;
          element.hidden = !(entry.state === '1' && visible < 10);
          if (!element.hidden) visible += 1;
        }
        group.hidden = visible === 0;
        if (focusedItem?.hidden && group.contains(focusedItem)) {
          group.querySelector('[data-grape-item]:not([hidden]) a')?.focus();
        }
      }
    };
    async function checkCollection(entry) {
      const url = new URL(entry.url, location.origin);
      if (url.origin !== location.origin || !/\/collections\/[^/]+\/?$/.test(url.pathname)) {
        throw new Error('Invalid grape destination');
      }
      const handle = decodeURIComponent(url.pathname.split('/').filter(Boolean).at(-1));
      url.search = '';
      url.hash = '';
      url.searchParams.set('view', 'grape-menu');
      // Start from page one: a stock change between page render and this read
      // must not leave a newly restocked wine on that page undetected.
      let page = 1;
      while (page) {
        url.searchParams.set('page', String(page));
        const response = await fetch(url, {
          credentials: 'same-origin', cache: 'no-store', signal: AbortSignal.timeout(15000),
        });
        if (!response.ok || response.redirected) throw new Error('Grape check unavailable');
        const result = await response.json();
        if (result.schema !== 1 || result.collection !== handle || result.page !== page ||
            typeof result.available !== 'boolean' || !Number.isInteger(result.next) ||
            (result.next !== 0 && result.next !== page + 1)) {
          throw new Error('Incomplete grape check');
        }
        if (result.available) return '1';
        page = result.next;
      }
      return '0';
    }
    // Two independent colour groups; within each group follow ranking and stop
    // when ten verified destinations have been found. No hidden cutoff at 50.
    const keys = [...new Set(groups.map((group) => group.dataset.grapeGroup))];
    await Promise.all(keys.map(async (key) => {
      const group = groups.find((candidate) => candidate.dataset.grapeGroup === key);
      let visible = 0;
      for (const element of group.querySelectorAll('[data-grape-item]')) {
        const entry = entries.get(element.dataset.grapeItem);
        if (entry.state === 'pending') {
          try {
            entry.state = await checkCollection(entry);
          } catch {
            // Network/login errors never authorize a customer-specific link.
            // Reopening the menu retries; successful results remain page-local.
            entry.state = 'pending';
          }
          update();
        }
        if (entry.state === '1') visible += 1;
        if (visible === 10) break;
      }
    }));
  }
  let running = false;
  const refresh = async () => {
    if (running) return;
    running = true;
    try { await initializeGrapeMenus(); } finally { running = false; }
  };
  void refresh();
  document.addEventListener('toggle', (event) => {
    if (event.target.open && event.target.querySelector('[data-grape-state="pending"]')) void refresh();
  }, true);
  document.addEventListener('shopify:section:load', refresh);
})();
